import React from 'react';

const BackButton = (props) => {
    return (
			<a data-v-778df7a6="" className="back-btn router-link-active button" style={{background: "rgb(39, 43, 69)", height: "45px", justifyContent: "start"}} onClick={props.showHisotry}>
				<i data-v-e56d064c="" data-v-778df7a6="" className="margin-right-5 fa-light fa-angles-left"></i>뒤로가기
			</a>
    )
}

export default BackButton;


// WEBPACK FOOTER //
// ./src/components/account/BackButton.js